import React, { Component, Fragment } from "react";
import SidebarV2 from "./sidebar-v2";
import {
  ADMIN_KEY,
  PROFILE_KEY,
  LOGOUT_KEY,
  HELP_CENTRE_KEY,
  FINANCES_KEY,
  INSIGHTS_KEY,
  TROY_SIDE_BAR_NAVIGATION,
  TROY_CLICK_INSIGHTS,
  TROY_CLICK_FINANCE,
  TROY_CLICK_EMPLOYEE,
  TROY_CLICK_PROFILE,
  TROY_CLICK_HC,
  TROY_CLICK_LOGOUT,
  TROY_CLICK_MENU,
  TROY_CLICK_UMP,
  TROY_CLICK_MARKETING,
  TROY_CHANGE_LANGUAGE,
  MENU_KEY,
  UMP_KEY,
  MARKETING_KEY,
  INVENTORY_KEY,
  TROY_CLICK_INVENTORY,
  PAYNOW_KEY,
  TROY_CLICK_PAYNOW,
  LS_IS_PAYNOW_QR_VISITED,
  HOME_KEY,
  TROY_CLICK_HOME,
  ORDER_KEY,
  FEEDBACK_KEY,
  TROY_CLICK_ORDER,
  TROY_CLICK_FEEDBACK,
  hasAccessDashboard,
  LANGUAGE_KEY,
  USER_GUIDE_KEY,
  INTRO_TO_FEATURE_KEY,
  MODAL_TYPE_LANGUAGE_SELECTION,
  TROY_HOME_ONBOARDING,
  TROY_PAGEVIEW,
  MODAL_TYPE_ONBOARDING,
  DASHBOARD_ONBOARDED_LS,
  TROY_CLICK_READ_GUIDE,
  hasAccessUMP,
  PROFILE_STATUS_DRAFT,
} from "../constants";
import "../assets/styles/troy.less";
import {
  profilePage,
  profileLogout,
  admin,
  GFRedirect,
  GFMenu,
  ADSUMP,
  GFInventory,
  isLoggedIn,
  changeLanguage,
  finances,
  insights,
  marketing,
  directToURl,
  isGlobalFeatureEnabled,
  openHelpCenter,
  payNow,
  home,
  order,
  feedback,
  haveAccessToFeature,
  getUserGuideFile,
  getSelectedMenu,
  getUserProfileStatus,
} from "../utils";
import {
  sessionStart,
  sessionEnd,
  checkIdleTimeout,
  isSessionTimedOut,
  forceLogout,
} from "../middleware/session-middleware.js";
import OnboardingModal from "../onboarding-modal";
import moment from "moment";

class TroySidebarMenu extends Component {
  state = {
    collapsed: false,
  };

  constructor(props) {
    super(props);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    const isOpenOnboardingModal = !localStorage.getItem(DASHBOARD_ONBOARDED_LS);
    this.state = {
      collapsed: this.props.collapsed,
      isModalOpen: isOpenOnboardingModal,
      modalType: isOpenOnboardingModal ? MODAL_TYPE_ONBOARDING : "",
      selectedPageKey: "",
      startViewOnboardingTime: new moment(),
    };
  }

  componentDidMount() {
    const { history, trackTroyAnalytics } = this.props;
    if (isSessionTimedOut()) {
      forceLogout(history, trackTroyAnalytics);
      return;
    }
    sessionStart();
    checkIdleTimeout(history, trackTroyAnalytics);
  }

  componentWillUnmount() {
    sessionEnd();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.collapsed === !this.props.collapsed) {
      this.setState({
        collapsed: newProps.collapsed,
      });
    }
  }

  onCollapse = (collapsed) => {
    const { trackTroyAnalytics } = this.props;
    let eventAction = "CLICK_EXPAND";
    if (collapsed) {
      eventAction = "CLICK_COLLAPSE";
    }

    trackTroyAnalytics(TROY_SIDE_BAR_NAVIGATION, eventAction, null);
    this.setState({ collapsed });
    this.props.IssliderCollpased(collapsed);
  };

  handleItemClick = (e) => {
    const { history, trackTroyAnalytics, overrideHandleItemClick } = this.props;
    if (!e.key) {
      return;
    }
    if (overrideHandleItemClick) {
      const shouldContinue = overrideHandleItemClick(e.key);
      if (!shouldContinue) {
        return;
      }
    }
    let ToUrl, params;
    let eventAction = "";
    let directPage = false;
    let eventLabel = null;
    switch (e.key) {
      case PROFILE_KEY:
        eventAction = TROY_CLICK_PROFILE;
        ToUrl = profilePage;
        break;
      case ADMIN_KEY:
        eventAction = TROY_CLICK_EMPLOYEE;
        ToUrl = admin;
        break;
      case LOGOUT_KEY:
        sessionEnd();
        eventAction = TROY_CLICK_LOGOUT;
        ToUrl = profileLogout;
        break;
      case HELP_CENTRE_KEY:
        eventAction = TROY_CLICK_HC;
        openHelpCenter(trackTroyAnalytics);
        break;
      case FINANCES_KEY:
      case FINANCES_KEY + "_tx":
      case FINANCES_KEY + "_st":
      case FINANCES_KEY + "_re":
        eventAction = TROY_CLICK_FINANCE;
        ToUrl = finances;
        params = `?page=${e.key.split("_")[1] || "tx"}`;
        break;
      case INSIGHTS_KEY:
        eventAction = TROY_CLICK_INSIGHTS;
        ToUrl = insights;
        break;
      case MENU_KEY:
        eventAction = TROY_CLICK_MENU;
        ToUrl = GFMenu;
        break;
      case UMP_KEY:
        eventAction = TROY_CLICK_UMP;
        ToUrl = ADSUMP;
        const isUMPNonMexUser =
          haveAccessToFeature(hasAccessUMP) &&
          getUserProfileStatus() === PROFILE_STATUS_DRAFT;
        if (!this.state.collapsed && !isUMPNonMexUser) {
          trackTroyAnalytics(
            TROY_SIDE_BAR_NAVIGATION,
            "PRODUCT_UPSELL.MARKETING_TAB_RED_LABEL_CLICK",
            null
          );
        }
        break;
      case INVENTORY_KEY:
        eventAction = TROY_CLICK_INVENTORY;
        ToUrl = GFInventory;
        break;
      case MARKETING_KEY:
        eventAction = TROY_CLICK_MARKETING;
        ToUrl = marketing;
        break;
      case PAYNOW_KEY:
        eventAction = TROY_CLICK_PAYNOW;
        ToUrl = payNow;
        break;
      case HOME_KEY:
        eventAction = TROY_CLICK_HOME;
        ToUrl = home;
        break;
      case ORDER_KEY:
        eventAction = TROY_CLICK_ORDER;
        ToUrl = order;
        break;
      case FEEDBACK_KEY:
        eventAction = TROY_CLICK_FEEDBACK;
        ToUrl = feedback;
        break;
      case LANGUAGE_KEY:
        this.handleOpenModal(MODAL_TYPE_LANGUAGE_SELECTION);
        break;
      case USER_GUIDE_KEY:
        eventAction = TROY_CLICK_READ_GUIDE;
        eventLabel = JSON.stringify({
          PAGE: getSelectedMenu(),
        });
        directPage = true;
        ToUrl = getUserGuideFile();
        break;
      case INTRO_TO_FEATURE_KEY:
        this.handleOpenModal(MODAL_TYPE_ONBOARDING);
        break;
      default:
        ToUrl = GFRedirect;
    }

    if (eventAction) {
      trackTroyAnalytics(TROY_SIDE_BAR_NAVIGATION, eventAction, eventLabel);
    }

    if (!ToUrl) return;

    if (directPage) {
      return window.open(ToUrl, "_blank");
    }

    if (ToUrl === payNow) {
      localStorage.setItem(LS_IS_PAYNOW_QR_VISITED, true);
    }

    this.setState({
      selectedPageKey: e.key,
    });
    directToURl(history, ToUrl, params);
  };

  handleOpenModal(modalType) {
    switch (modalType) {
      case MODAL_TYPE_ONBOARDING:
        this.setState({
          startViewOnboardingTime: new moment(),
        });
        break;
      default:
        break;
    }

    this.setState({
      isModalOpen: true,
      modalType: modalType,
    });
  }

  handleCloseModal(modalType) {
    switch (modalType) {
      case MODAL_TYPE_ONBOARDING:
        this.handleCloseOnboardingModal();
        break;
      default:
        break;
    }

    this.setState({
      isModalOpen: false,
    });
  }

  handleLogout = () => {
    const { history, trackTroyAnalytics } = this.props;

    let eventAction = TROY_CLICK_LOGOUT;
    let ToUrl = profileLogout;
    trackTroyAnalytics(TROY_SIDE_BAR_NAVIGATION, eventAction, null);
    sessionEnd();

    directToURl(history, ToUrl);
  };

  handleClickLanguage = (e) => {
    const { updateLanguage, trackTroyAnalytics } = this.props;
    trackTroyAnalytics(
      TROY_SIDE_BAR_NAVIGATION,
      TROY_CHANGE_LANGUAGE,
      JSON.stringify({
        DEFAULT_LANGUAGE_SHOWED: localStorage.getItem("lang"),
        SELECTED_LANGAUGE: e.key,
      })
    );
    changeLanguage(e.key, updateLanguage);
  };

  handleCloseOnboardingModal = () => {
    const { trackTroyAnalytics } = this.props;
    localStorage.setItem(DASHBOARD_ONBOARDED_LS, true);

    const currentTime = new moment();
    if (this.state.startViewOnboardingTime) {
      const viewTime = moment
        .duration(currentTime.diff(this.state.startViewOnboardingTime))
        .as("milliseconds");
      trackTroyAnalytics(
        TROY_HOME_ONBOARDING,
        TROY_PAGEVIEW,
        JSON.stringify({ VIEW_TIME: viewTime })
      );
    }
  };

  render() {
    const { trackTroyAnalytics, overrideSelectedPage, menuTooltip } =
      this.props;
    const { isModalOpen } = this.state;
    const isPayNowVisited = Boolean(
      localStorage.getItem(LS_IS_PAYNOW_QR_VISITED)
    );
    if (!isPayNowVisited && window.location.pathname.includes(PAYNOW_KEY)) {
      localStorage.setItem(LS_IS_PAYNOW_QR_VISITED, true);
    }

    const propsSidebar = {
      handleItemClick: this.handleItemClick,
      handleClickLanguage: this.handleClickLanguage,
      handleSelectLanguage: this.handleSelectLanguage,
      handleLogout: this.handleLogout,
      handleOpenModal: this.handleOpenModal,
      handleCloseModal: this.handleCloseModal,
      handleLanguageOpenModal: this.handleLanguageOpenModal,
      handleLanguageCloseModal: this.handleLanguageCloseModal,
      onCollapse: this.onCollapse,
      isModalOpen: isModalOpen,
      modalType: this.state.modalType,
      collapsed: this.state.collapsed,
      trackTroyAnalytics: trackTroyAnalytics,
      overrideSelectedPage,
      menuTooltip: menuTooltip || {},
      selectedPageKey: this.state.selectedPageKey,
      shouldShowLabel: this.props.shouldShowLabel,
    };

    return (
      <div className="troy-sidebar">
        {isLoggedIn() ? (
          <Fragment>
            <SidebarV2 {...propsSidebar} />
            {this.state.isModalOpen &&
              this.state.modalType === MODAL_TYPE_ONBOARDING && (
                <OnboardingModal
                  onClose={() => this.handleCloseModal(MODAL_TYPE_ONBOARDING)}
                />
              )}
          </Fragment>
        ) : null}
      </div>
    );
  }
}

export { TroySidebarMenu };
